<template>
  <div class="app-container">
    <Container
      :title="t('process.processList')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :hasCreate="false /*$hasPermission(['approvalform_M'])*/"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <SimpleTable
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :operateColumnWidth="$hasPermission(['SYS_WORKFLOW_W']) ? 220:80"
        >
          <template
            #default="slotProps"
          >
            <el-button
              v-if="$hasPermission(['SYS_WORKFLOW_W'])"
              @click="handleExamine(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import Container from '@/components/form/container/Container.vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { createModel } from '@/utils/component'
import { ProcessModel, ProcessPageParamModel } from '@/model/process/processModel'
import { getProcessPageList } from '@/apis/process/process'

export default defineComponent({
  name: 'ProcessPageList',
  components: {
    SearchForm,
    SimpleTable,
    Container
  },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const searchStruct = [
      { prop: 'name', label: t('process.processName'), component: 'el-input', type: 'text', model: '' },
      {
        prop: 'active',
        label: t('process.isActive'),
        component: 'el-select',
        options: [
          { label: t('process.yes'), value: true },
          { label: t('process.no'), value: false }
        ]
      }
    ]
    const formatActive = (status: boolean | null) => {
      if (status === true) {
        return t('process.yes')
      } else if (status === false) {
        return t('process.no')
      }
      return null
    }
    const processTableStruct = [
      { prop: 'id', label: t('process.id') },
      { prop: 'name', label: t('process.processName') },
      { prop: 'companyCode', label: t('company.companyCode') },
      { prop: 'active', label: t('process.active'), formatter: (row: any) => formatActive(row.active) }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as ProcessPageParamModel,
      tableData: Array<ProcessModel>(),
      columnStruct: processTableStruct,
      listLoading: true,
      limit: 10,
      total: 0,
      page: 1,
      handleCurrentChange(page?: any) {
        dataMap.getPageList(page)
      },
      handleSizeChange(val: any) {
        dataMap.getPageList(null, val)
      },
      async getPageList(page?: any, limit?: any) {
        if (page) {
          dataMap.page = page
        }
        if (limit) {
          dataMap.limit = limit
        }
        dataMap.listLoading = true
        const params: ProcessPageParamModel = {
          name: dataMap.searchFormModel.name,
          active: dataMap.searchFormModel.active,
          pageCurrent: dataMap.page,
          pageSize: dataMap.limit
        }
        const data = await getProcessPageList(params)
        if (data && data.data && data.data.list.length > 0) {
          dataMap.tableData = data.data.list
        } else {
          dataMap.tableData = []
        }
        dataMap.total = data?.data.totalCount ?? 0

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getPageList()
      },
      resetForm() {
        console.log('reset')
      }
    })
    const handleExamine = (row: ProcessModel) => {
      router.push({ path: `processEdit/${row.id}` })
    }
    onMounted(() => {
      dataMap.getPageList(null, 10)
    })
    return {
      t,
      handleExamine,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>

</style>
